import { query } from 'src/utils/request';
// 项目绩效监控列表查询
export const getBudgetEpProjectPerfMonitorList = async data => {
  return query('/zlb/budget/ep/project-perf-monitor/manage/page', {
    method: 'post',
    data,
  });
};
// 项目绩效监控审核列表查询
export const getBudgetEpProjectPerfAuditList = async data => {
  return query('/zlb/budget/ep/project-perf-monitor/audit/page', {
    method: 'post',
    data,
  });
};
// 项目绩效监控填报数据预填充
export const getBudgetEpProjectPerfMonitorFill = async data => {
  return query('/zlb/budget/ep/project-perf-monitor/manage/pre-fill-data', {
    method: 'post',
    data,
  });
};
// 项目绩效自评列表查询
export const getBudgetEpProjectPerfEvalManageList = async data => {
  return query('/zlb/budget/ep/project-perf-eval/manage/page', {
    method: 'post',
    data,
  });
};
// 项目绩效自评审核列表查询
export const getBudgetEpProjectPerfEvalAuditList = async data => {
  return query('/zlb/budget/ep/project-perf-eval/audit/page', {
    method: 'post',
    data,
  });
};

// 项目绩效自评填报数据预填充
export const getBudgetEpProjectPerfEvalManagePreFill = async data => {
  return query('/zlb/budget/ep/project-perf-eval/manage/pre-fill-data', {
    method: 'post',
    data,
  });
};

// 项目绩效自评明细导出提交
export const getBudgetEpProjectPerfEvalExportDetail = async data => {
  return query('/zlb/budget/ep/project-perf-eval/export/detail/submit', {
    method: 'post',
    data,
  });
};

// 部门绩效自评列表查询
export const getBudgetEpProjectDepPerfList = async data => {
  return query('/zlb/budget/ep/dep-perf/page', {
    method: 'post',
    data,
  });
};
